import React from 'react';
import { SvgIcon } from '@onsolve/onsolve-ui-components';

const Lockbox = props => (
    <SvgIcon {...props}>
        <path
            d="M16 13.07v1.465c0 .801-.645 1.453-1.444 1.463a.889.889 0 00-.873-.814.889.889 0 00-.873.815h-1.764a.889.889 0 00-.873-.815A.889.889 0 009.3 16H7.536a.889.889 0 00-.873-.815.889.889 0 00-.873.815H3.74v-1.72c0-.658.508-1.193 1.141-1.208H16zm-3.802-6.954c.474 0 .86.396.874.89V12.52H7.827v-1.555c.733-.157 1.234-.869 1.158-1.648-.075-.779-.701-1.371-1.45-1.371-.747 0-1.373.592-1.449 1.371-.074.769.412 1.472 1.129 1.641l.03.007v1.555H4.914c-.955.001-1.73.803-1.748 1.798v.033h-.292c-.474 0-.86-.396-.874-.89V7.031c0-.497.378-.9.85-.914H12.198zM7.444.26c1.794 0 3.249 1.511 3.249 3.375v1.84h-.59v-1.84c0-1.525-1.19-2.761-2.659-2.761-1.467 0-2.657 1.236-2.657 2.76v1.842h-.59V3.635C4.196 1.77 5.65.26 7.443.26z"
            fillRule="evenodd"
            stroke="none"
        />
    </SvgIcon>
);

export default Lockbox;
